/**
 * TestimonialsSection — grid of writer quote cards sourced from i18n.
 * Avatar initials are derived from the first letter of each word in `name`.
 */

import { useTranslation } from 'react-i18next';

import {
  Section,
  Container,
  SectionHeader,
  SectionEyebrow,
  SectionTitle,
  TestimonialsGrid,
  TestimonialCard,
  TestimonialQuote,
  TestimonialAuthor,
  TestimonialAvatar,
  TestimonialName,
  TestimonialRole,
} from '../../common/LandingPage.styled';

interface Testimonial {
  quote: string;
  name: string;
  role: string;
}

/** First letter of each space-separated word in a name (e.g. "Elena Park" → "EP"). */
function initialsOf(name: string): string {
  return name
    .split(' ')
    .map((w) => w[0])
    .join('');
}

export function TestimonialsSection() {
  const { t } = useTranslation();
  const testimonials = t('landing.testimonials.list', { returnObjects: true }) as Testimonial[];

  return (
    <Section>
      <Container>
        <SectionHeader>
          <SectionEyebrow>{t('landing.testimonials.eyebrow')}</SectionEyebrow>
          <SectionTitle>{t('landing.testimonials.title')}</SectionTitle>
        </SectionHeader>
        <TestimonialsGrid>
          {testimonials.map(({ quote, name, role }) => (
            <TestimonialCard key={name}>
              <TestimonialQuote>"{quote}"</TestimonialQuote>
              <TestimonialAuthor>
                <TestimonialAvatar>{initialsOf(name)}</TestimonialAvatar>
                <div>
                  <TestimonialName>{name}</TestimonialName>
                  <TestimonialRole>{role}</TestimonialRole>
                </div>
              </TestimonialAuthor>
            </TestimonialCard>
          ))}
        </TestimonialsGrid>
      </Container>
    </Section>
  );
}

export default TestimonialsSection;
